// extracted by mini-css-extract-plugin
export default {"parallax":"ParallaxImg_parallax__-9y5g"};